import { useMutation } from "@tanstack/react-query";
import { fetch } from "libs";
import {POST_CREATE_KESSPAY_CHECKOUT_SESSION} from "api"


const createKessPayCheckoutSession = async (plan_name: string) => {
  const POST_CREATE_KESSPAY_CHECKOUT_SESSION_COM = POST_CREATE_KESSPAY_CHECKOUT_SESSION(plan_name);

  const response = await fetch(POST_CREATE_KESSPAY_CHECKOUT_SESSION_COM, {
    method: "POST",
    credentials: "include",
  });

  if (!response.payment_url) {
    throw new Error("Payment URL not found in response");
  }

  return {
    session_id: response.session_id,
    payment_url: response.payment_url
  };
};

export const useCreateKessPayCheckoutSession = () => {
  return useMutation({
    mutationFn: async ({ plan_name }: { plan_name: string }) =>
      await createKessPayCheckoutSession(plan_name),
    onSuccess: (data) => {
      console.log("Created KessPay session successfully");
      // We'll let the component handle the redirect for more flexibility
    },
    onError: (error: any) => {
      console.error("Error creating KessPay session:", error);
    },
  });
};

export default useCreateKessPayCheckoutSession;